//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import projects from '~/data/projects'

export default {
    name: 'ListProjects',

    data(){ return {
        projects: projects.externals,
        visible: false,
        load: false,
    }},

    mounted(){

    },

    computed: {

    },

    methods: {
        onIntersection (entry) {
            if(this.visible) return;

            if(entry.isIntersecting)
            this.load = true

            setTimeout(() => this.visible = entry.isIntersecting, 100)
            // setTimeout(() => this.onIntersection({ isIntersecting: !this.visible}), 1300)
        },

    }
}
